export const navigatorMixin = {
  methods: {
    setActiveNode(name) {
      setTimeout(() => {
        let nodes = document.querySelectorAll('.vtl-node-main');

        nodes.forEach(item => {
          item.classList.remove('active-icon_node')
        });

        for (let item of nodes) {
          let contentItem = item.querySelector('.vtl-node-content');
          let content = contentItem.innerHTML.trim();
          let hint = document.querySelector('.btn-hint-navigator');
          let maxWordLength = 20;
          if (window.matchMedia('(max-width: 1500px)').matches) {
            maxWordLength = 12
          };

          if (window.matchMedia('(max-width: 1370px)').matches) {
            maxWordLength = 10
          };

          function mouseEnter(text) {
            return function (e) {
              e = e || window.event;

              let x = e.clientX;
              let y = e.clientY;

              hint.style.top = `${y + 25}px`;
              hint.style.left = `${x}px`;
              hint.style.display = 'block';
              hint.innerHTML = text
            }
          }

          function mouseLeave() {
            hint.style.display = 'none';
          }

          if (content === name) {
            item.classList.add('active-icon_node')
          }

          //ищем длинные и режем их

          if (content.length > maxWordLength) {
            let checkHint = contentItem.classList.contains('hint-cont');
            if (!checkHint) {
              contentItem.addEventListener('mouseenter', mouseEnter(content));
              contentItem.addEventListener('mouseleave', mouseLeave);
              contentItem.classList.add('hint-cont');

              content = content.slice(0, maxWordLength) + '...';
              contentItem.innerHTML = content;
            }

          }
        }
      }, 200)
    }
  }
}
